import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, Observer } from 'rxjs';


export function createDNIDuplicateValidator(c: any): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        let exist = false;

        if (!c.edit_mode || c.values.dni !== control.value) {
            exist = c.InscripcionesS.existeInivitado(control.value);
        }
        return (exist?{DNIDuplicate: true}:null);
    };
}

export function DNIAlreadyExistsValidator(InscripcionesS: any): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

      return new Observable( (observer: Observer<ValidationErrors | null>) => {
          // console.log("Validado dni duplicados");
          const dni = control.get('dni')!.value.toUpperCase();
          if (dni === '') {
              observer.next(null);
              observer.complete()
              return;
          }
          InscripcionesS.existeDNI(dni).subscribe(
              (r:any) => {
                  observer.next((r?{DNIExiste: true}:null));
                  observer.complete()
              }
          );

      });

  }
}
export function DNIMediadorValidator(Colegiados: any): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

      return new Observable( (observer: Observer<ValidationErrors | null>) => {
          // console.log("Validado Mediador. Tipo incripción: " + Colegiados.getFieldValue('tipo_inscripcion'));
          const dni = control.get('dni')!.value.toUpperCase();
          console.log("Validando dni: " + dni);
          const tipo_inscripcion = control.get('tipo_inscripcion')!.value;
          if (dni === '' || tipo_inscripcion != 1) {
              // console.log("\t no es tipo Mediador devuelvo ok");
              observer.next(null);
              observer.complete()
              return;
          }
          // console.log("\t Es tipo Mediador comprobando colegido");
          Colegiados.esMediador(dni).subscribe(
              (r:any) => {
                  // console.log("\tRespuesta recibida en validator ", r);
                  // observer.next(r?null:{noMediador: true});
                  observer.next(r?null:{noMediador: true});
                  observer.complete()
              }
          );

      });

  }
}
